import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Form,
  Input,
  // DatePicker,
  // Select,
  Radio,
  Space,
  Image,
  message,
  Card,
  Tag,
  // Collapse,
  Spin
} from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
import CustomButton from '@/common/CustomButton';
import truck from '../images/truck-delivery-done.gif';
import { useDispatch, useSelector } from 'react-redux';
import { createVehicleStorage, getDocsbyId } from '../../redux/slice';
import { history } from 'app/history';
import Layout from '@/common/Layout';
import { useParams } from 'react-router-dom';
import { EditOutlined } from '@ant-design/icons';
import VerificationModal from '../VerificationModal';
import { getLoggedInUser, getRoles } from 'utilities/helpers';

// const { Panel } = Collapse;
const { TextArea } = Input;

const InvoiceDetailsPage = ({ loading }) => {
  const { material } = useSelector((state) => state.material);
  const params = useParams();
  const dispatch = useDispatch();

  const { user } = getLoggedInUser();
  const { Superadmindata } = getRoles('Warehouse');

  const [form] = Form.useForm();

  const [truckShow, setTruckShow] = useState(false);
  const [materials, setMaterials] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [isVehicleStorageEdit, setIsVehicleStorageEdit] = useState(false);
  const [isModal, setIsModal] = useState(false);

  const handleCapacity = (e) => {
    const { name, value } = e.target;
    setMaterials({ ...materials, [name]: value });
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo.errorFields.length);
    if (errorInfo.errorFields.length > 0) {
      message.error(
        'Please select a response to all the questions in the checklist'
      );
    }
  };
  console.log(localStorage.getItem('inv_num'));
  const onFinish = (values) => {
    // Create FormData similar to CreateMaterialPage
    let formData = new FormData();
    formData.append('vehicle_cleanliness', materials.vehicle_cleanliness);
    formData.append('storage_conditions', materials.storage_conditions);
    formData.append('storage_enclose', materials.storage_enclose);
    formData.append(
      'vehicle_storage_comments',
      values.veh_storage_comments || ''
    );
    formData.append('data_logger', materials.data_logger);
    formData.append('dedusting_status', materials.dedusting_status);
    formData.append('labels_defaced', materials.labels_defaced);
    formData.append('seal_integrity', materials.seal_integrity);
    formData.append(
      'material_ver_comments',
      values.material_ver_comments || ''
    );

    // If material_status is 'veh_ver_approved', send 'id' instead of 'document_id'
    if (material?.material_status === 'veh_ver_approved') {
      // For Material Verification submission, send id (vehicle_storage_area id or material id)
      // const idToSend = material?.vehicle_storage_area?.id || material?.id || params.id;
      formData.append('id', params.id);
    } else {
      // For Vehicle Storage submission, send document_id
      formData.append('document_id', params.id);
    }

    setTruckShow(true);

    dispatch(createVehicleStorage(formData)).then(function (response) {
      if (response?.payload?.success) {
        setTimeout(() => {
          message.success(response?.payload?.message);
          setIsVehicleStorageEdit(false);
          if (response?.payload?.data?.material_status === 'veh_ver_approved') {
            // Redirect to same page to show Material Verification section
            history.push(`/vehicle-storage/${response?.payload?.data?.id}`);
            // Reload the page data
            handleGetDocsbyId();
          } else {
            history.push('/pending-receipts');
          }
        }, 2000);
      } else {
        setTruckShow(false);
        message.error(response?.payload?.message || 'Failed to submit');
      }
    });
  };

  const handleStandardCancel = () => {
    history.push('/dashboard');
  };

  useEffect(() => {
    form.setFieldsValue({
      invoice_num: localStorage.getItem('invoice_num')
    });
  }, []);

  useEffect(() => {
    handleGetDocsbyId();
  }, [isModal, params.id]);

  const handleGetDocsbyId = () => {
    const payload = {
      id: params.id
    };
    dispatch(getDocsbyId(payload));
  };

  // Convert boolean to "Yes"/"No" string helper function
  const convertBooleanToString = (value) => {
    if (value === true) return 'Yes';
    if (value === false) return 'No';
    return value || '';
  };

  // Pre-populate vehicle storage and material verification fields
  useEffect(() => {
    if (material && Object.keys(material).length > 0) {
      // Populate vehicle storage fields if data exists
      const vehicleStorage = material?.vehicle_storage_area || material;

      if (
        vehicleStorage?.vehicle_cleanliness !== undefined ||
        vehicleStorage?.storage_enclose !== undefined ||
        vehicleStorage?.storage_conditions !== undefined
      ) {
        form.setFieldsValue({
          vehicle_cleanliness: convertBooleanToString(
            vehicleStorage.vehicle_cleanliness
          ),
          storage_enclose: convertBooleanToString(
            vehicleStorage.storage_enclose
          ),
          storage_conditions: convertBooleanToString(
            vehicleStorage.storage_conditions
          ),
          veh_storage_comments: vehicleStorage.vehicle_storage_comments || ''
        });
        setMaterials((prev) => ({
          ...prev,
          vehicle_cleanliness: convertBooleanToString(
            vehicleStorage.vehicle_cleanliness
          ),
          storage_enclose: convertBooleanToString(
            vehicleStorage.storage_enclose
          ),
          storage_conditions: convertBooleanToString(
            vehicleStorage.storage_conditions
          )
        }));
      }

      // Populate material verification fields if data exists and status is 'veh_ver_approved'
      if (material?.material_status === 'veh_ver_approved') {
        const materialVerification =
          material?.material_verification || material;

        if (
          materialVerification?.data_logger_received !== undefined ||
          materialVerification?.vendor_status_label_defaced !== undefined ||
          materialVerification?.material_dedusting_status !== undefined ||
          materialVerification?.container_seal_integrity !== undefined
        ) {
          form.setFieldsValue({
            data_logger: convertBooleanToString(
              materialVerification.data_logger_received
            ),
            labels_defaced: convertBooleanToString(
              materialVerification.vendor_status_label_defaced
            ),
            dedusting_status: convertBooleanToString(
              materialVerification.material_dedusting_status
            ),
            seal_integrity: convertBooleanToString(
              materialVerification.container_seal_integrity
            ),
            material_ver_comments:
              materialVerification.material_ver_comments || ''
          });
          setMaterials((prev) => ({
            ...prev,
            data_logger: convertBooleanToString(
              materialVerification.data_logger_received
            ),
            dedusting_status: convertBooleanToString(
              materialVerification.material_dedusting_status
            ),
            labels_defaced: convertBooleanToString(
              materialVerification.vendor_status_label_defaced
            ),
            seal_integrity: convertBooleanToString(
              materialVerification.container_seal_integrity
            )
          }));
        }
      }
    }
  }, [material]);

  const handleEdit = () => {
    setIsEdit(true);
    form.setFieldsValue({
      gravity:
        material?.for_graviti == true
          ? 'Yes'
          : material?.for_graviti == false
          ? 'No'
          : 'NA',
      invoice_dc_boe_available:
        material?.invoice_dc_boe_available == true
          ? 'Yes'
          : material?.invoice_dc_boe_available == false
          ? 'No'
          : 'NA',
      invoice_number: material?.invoice_number,
      po_available:
        material?.po_available == true
          ? 'Yes'
          : material?.po_available == false
          ? 'No'
          : 'NA',
      coa_coc_msda_available:
        material?.coa_coc_msda_available == true
          ? 'Yes'
          : material?.coa_coc_msda_available == false
          ? 'No'
          : 'NA',
      material_vendor_status: material?.material_vendor_status,
      manufacture_site_address_matching:
        material?.manufacture_site_address_matching == true
          ? 'Yes'
          : material?.manufacture_site_address_matching == false
          ? 'No'
          : 'NA'
    });
  };

  const handleVehicleStorageEdit = () => {
    setIsVehicleStorageEdit(true);
    const vehicleStorage = material?.vehicle_storage_area || material;
    form.setFieldsValue({
      vehicle_cleanliness: convertBooleanToString(
        vehicleStorage?.vehicle_cleanliness
      ),
      storage_enclose: convertBooleanToString(vehicleStorage?.storage_enclose),
      storage_conditions: convertBooleanToString(
        vehicleStorage?.storage_conditions
      ),
      veh_storage_comments: vehicleStorage?.vehicle_storage_comments || ''
    });
  };

  // Check if vehicle storage data exists
  const hasVehicleStorageData = () => {
    const vehicleStorage = material?.vehicle_storage_area || material;
    return (
      vehicleStorage?.vehicle_cleanliness !== undefined ||
      vehicleStorage?.storage_enclose !== undefined ||
      vehicleStorage?.storage_conditions !== undefined
    );
  };
  console.log(material);
  return (
    <Layout sider={false}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Space direction="vertical">
          <Card
            title="DOCUMENT VERIFICATION"
            className={styles.CustomPanel}
            extra={
              user?.level == 3 || Superadmindata?.[0]?.level == 3 ? (
                <EditOutlined onClick={() => handleEdit()} />
              ) : (
                ''
              )
            }
          >
            {isEdit ? (
              <>
                <Row gutter={24}>
                  <Col xs={24} xl={8} span={8}>
                    <FormItem
                      label="Is the material meant for graviti?"
                      name="gravity"
                      rules={[
                        {
                          required: true,
                          message: 'Choose Yes/No'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Radio.Group
                        onChange={handleCapacity}
                        className={styles.customRadio}
                        name="gravity"
                      >
                        <Radio value="Yes">Yes</Radio>
                        <Radio value="No">No</Radio>
                      </Radio.Group>
                    </FormItem>
                  </Col>

                  <Col xs={24} xl={8} span={8}>
                    <FormItem
                      label="Invoice/DC/BOE Number available"
                      name="invoice_dc_boe_available"
                      rules={[
                        {
                          required: true,
                          message: 'Choose Yes/No'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Radio.Group
                        onChange={handleCapacity}
                        className={styles.customRadio}
                        name="invoice_exist"
                      >
                        <Radio value="Yes">Yes</Radio>
                        <Radio value="No">No</Radio>
                      </Radio.Group>
                    </FormItem>
                  </Col>
                  <Col xs={24} xl={8} span={8}>
                    <FormItem
                      label="Invoice/DC/BOE Number"
                      name="invoice_number"
                      rules={[
                        {
                          required: true,
                          message: 'Enter Invoice number'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input
                        placeholder="Enter Invoice number"
                        name="invoice_number"
                        onChange={handleCapacity}
                      />
                    </FormItem>
                  </Col>
                  <Col xs={24} xl={8} span={8}>
                    <FormItem
                      label="Purchase Order available"
                      name="po_available"
                      rules={[
                        {
                          required: true,
                          message: 'Choose Yes/No'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Radio.Group
                        onChange={handleCapacity}
                        className={styles.customRadio}
                        name="po_available"
                      >
                        <Radio value="Yes">Yes</Radio>
                        <Radio value="No">No</Radio>
                      </Radio.Group>
                    </FormItem>
                  </Col>
                  <Col xs={24} xl={8} span={8}>
                    <FormItem
                      label="COA/COC, MSDS available"
                      name="coa_coc_msda_available"
                      rules={[
                        {
                          required: true,
                          message: 'Choose Yes/No'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Radio.Group
                        onChange={handleCapacity}
                        className={styles.customRadio}
                        name="coa_coc_msda_available"
                      >
                        <Radio value="Yes">Yes</Radio>
                        <Radio value="No">No</Radio>
                      </Radio.Group>
                    </FormItem>
                  </Col>
                  <Col xs={24} xl={8} span={8}>
                    <FormItem
                      label="Material Vendor Status"
                      name="material_vendor_status"
                      rules={[
                        {
                          required: true,
                          message: 'Choose Yes/No'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Radio.Group
                        onChange={handleCapacity}
                        className={styles.customRadio}
                        name="material_vendor_status"
                      >
                        <Radio value="approved">Approved</Radio>
                        <Radio value="prov">Prov Approved</Radio>
                        <Radio value="New">New</Radio>
                      </Radio.Group>
                    </FormItem>
                  </Col>
                  <Col span={18}>
                    <FormItem
                      label="Manufacturing site address matching with Provisionally
                Approved/Approved Vendor list"
                      name="manufacture_site_address_matching"
                      rules={[
                        {
                          required: true,
                          message: 'Choose Yes/No'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Radio.Group
                        onChange={handleCapacity}
                        className={styles.customRadio}
                        name="approved_vendor"
                      >
                        <Radio value="Yes">Yes</Radio>
                        <Radio value="No">No</Radio>
                      </Radio.Group>
                    </FormItem>
                  </Col>
                </Row>
                <FormItem className="text-center">
                  <Space>
                    <CustomButton
                      htmlType="button"
                      onClick={handleStandardCancel}
                      className={styles.border_button}
                    >
                      Cancel
                    </CustomButton>
                    {truckShow ? (
                      <Image
                        src={truck}
                        preview={false}
                        style={{ width: '100px !important', height: '100px' }}
                      />
                    ) : (
                      <CustomButton
                        type="primary"
                        // htmlType="submit"
                        loading={loading}
                        className={styles.border_button}
                        onClick={() => setIsModal(true)}
                        ghost
                      >
                        Initiate Verification
                      </CustomButton>
                    )}
                  </Space>
                </FormItem>
              </>
            ) : (
              <Row gutter={24}>
                <Col xs={24} xl={8} span={8}>
                  <p className={styles.customLable}>
                    Is the Material meant for Graviti?
                  </p>
                  <p className={styles.customValue}>
                    {material?.for_graviti == true
                      ? 'Yes'
                      : material?.for_graviti == false
                      ? 'No'
                      : 'NA'}
                  </p>
                </Col>
                <Col xs={24} xl={8} span={8}>
                  <p className={styles.customLable}>
                    Invoice/DC/BOE Number Available?
                  </p>
                  <p className={styles.customValue}>
                    {material?.invoice_dc_boe_available == true
                      ? 'Yes'
                      : material?.invoice_dc_boe_available == false
                      ? 'No'
                      : 'NA'}
                  </p>
                </Col>
                <Col xs={24} xl={8} span={8}>
                  <p className={styles.customLable}>Invoice/DC/BOE Number</p>
                  <p className={styles.customValue}>
                    {material?.invoice_number || 'NA'}
                  </p>
                </Col>
                <Col xs={24} xl={8} span={8}>
                  <p className={styles.customLable}>
                    Purchase Order Available?
                  </p>
                  <p className={styles.customValue}>
                    {material?.po_available == true
                      ? 'Yes'
                      : material?.po_available == false
                      ? 'No'
                      : 'NA'}
                  </p>
                </Col>
                <Col xs={24} xl={8} span={8}>
                  <p className={styles.customLable}>COA/COC, MSDS Available?</p>
                  <p className={styles.customValue}>
                    {material?.coa_coc_msda_available == true
                      ? 'Yes'
                      : material?.coa_coc_msda_available == false
                      ? 'No'
                      : 'NA'}
                  </p>
                </Col>
                <Col xs={24} xl={8} span={8}>
                  <p className={styles.customLable}>Material Vendor Status</p>
                  <p className={styles.customValue}>
                    {material?.material_vendor_status?.toUpperCase() || 'NA'}
                  </p>
                </Col>
                <Col xs={24} xl={8} span={8}>
                  <p className={styles.customLable}>
                    Manufacturing site address matching with Provisionally
                    Approved/Approved Vendor list
                  </p>
                  <p className={styles.customValue}>
                    {material?.manufacture_site_address_matching == true
                      ? 'Yes'
                      : material?.manufacture_site_address_matching == false
                      ? 'No'
                      : 'NA'}
                  </p>
                </Col>
                <Col xs={24} xl={8} span={8}>
                  <p className={styles.customLable}>
                    Document Verification Files
                  </p>
                  <p className={styles.customValue}>
                    {material?.doc_verify_uploads?.length
                      ? material?.doc_verify_uploads.map((file, index) => (
                          <Tag key={index}>
                            <a
                              href={`${
                                process.env.REACT_APP_STORAGE_URL
                              }${file.doc_url.split('/').pop()}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {file.doc_name}
                            </a>
                          </Tag>
                        ))
                      : 'NA'}
                  </p>
                </Col>
                <Col xs={24} xl={8} span={8}>
                  <p className={styles.customLable}>Comments</p>
                  <p className={styles.customValue}>
                    {material?.doc_ver_comments || 'NA'}
                  </p>
                </Col>
              </Row>
            )}
          </Card>

          <Card
            title="VEHICLE VERIFICATION"
            className={styles.CustomPanel}
            extra={
              hasVehicleStorageData() &&
              !isVehicleStorageEdit &&
              (user?.level == 3 || Superadmindata?.[0]?.level == 3) ? (
                <EditOutlined onClick={() => handleVehicleStorageEdit()} />
              ) : (
                ''
              )
            }
          >
            {hasVehicleStorageData() && !isVehicleStorageEdit ? (
              // Read-only view when data exists
              <Row gutter={24}>
                <Col xs={24} xl={8} span={8}>
                  <p className={styles.customLable}>Vehicle cleanliness</p>
                  <p className={styles.customValue}>
                    {(() => {
                      const vehicleStorage =
                        material?.vehicle_storage_area || material;
                      return (
                        convertBooleanToString(
                          vehicleStorage?.vehicle_cleanliness
                        ) || 'NA'
                      );
                    })()}
                  </p>
                </Col>
                <Col xs={24} xl={8} span={8}>
                  <p className={styles.customLable}>
                    Storage in enclosed condition
                  </p>
                  <p className={styles.customValue}>
                    {(() => {
                      const vehicleStorage =
                        material?.vehicle_storage_area || material;
                      return (
                        convertBooleanToString(
                          vehicleStorage?.storage_enclose
                        ) || 'NA'
                      );
                    })()}
                  </p>
                </Col>
                <Col xs={24} xl={8} span={8}>
                  <p className={styles.customLable}>
                    Storage condition available
                  </p>
                  <p className={styles.customValue}>
                    {(() => {
                      const vehicleStorage =
                        material?.vehicle_storage_area || material;
                      return (
                        convertBooleanToString(
                          vehicleStorage?.storage_conditions
                        ) || 'NA'
                      );
                    })()}
                  </p>
                </Col>
                <Col xs={24} xl={24} span={8}>
                  <p className={styles.customLable}>Comments</p>
                  <p className={styles.customValue}>
                    {(() => {
                      const vehicleStorage =
                        material?.vehicle_storage_area || material;
                      return vehicleStorage?.vehicle_storage_comments || 'NA';
                    })()}
                  </p>
                </Col>
              </Row>
            ) : (
              // Editable form when no data or in edit mode
              <Row gutter={24}>
                <Col xs={24} xl={8} span={8}>
                  <FormItem
                    label="Vehicle cleanliness"
                    name="vehicle_cleanliness"
                    rules={[
                      {
                        required: true,
                        message: 'Choose Yes/No'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Radio.Group
                      onChange={handleCapacity}
                      className={styles.customRadio}
                      name="vehicle_cleanliness"
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </FormItem>
                </Col>
                <Col xs={24} xl={8} span={8}>
                  <FormItem
                    label="Storage in  enclosed condition"
                    name="storage_enclose"
                    rules={[
                      {
                        required: true,
                        message: 'Choose Yes/No'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Radio.Group
                      onChange={handleCapacity}
                      className={styles.customRadio}
                      name="storage_enclose"
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </FormItem>
                </Col>
                <Col xs={24} xl={8} span={8}>
                  <FormItem
                    label="Storage condition available"
                    name="storage_conditions"
                    rules={[
                      {
                        required: true,
                        message: 'Choose Yes/No'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Radio.Group
                      onChange={handleCapacity}
                      className={styles.customRadio}
                      name="storage_conditions"
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </FormItem>
                </Col>
                <Col xs={24} xl={24} span={8}>
                  <FormItem
                    label="Comments"
                    name="veh_storage_comments"
                    rules={[
                      {
                        required: false,
                        message: 'Enter comments'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <TextArea placeholder="Enter comments"></TextArea>
                  </FormItem>
                </Col>
              </Row>
            )}
          </Card>

          {/* Show Material Verification section when material_status is 'veh_ver_approved' */}
          {material?.material_status === 'veh_ver_approved' && (
            <Card title="MATERIAL VERIFICATION" className={styles.CustomPanel}>
              <Row gutter={24}>
                <Col xs={24} xl={6} span={8}>
                  <FormItem
                    label="Data logger received along with consignment"
                    name="data_logger"
                    rules={[
                      {
                        required: true,
                        message: 'Choose Yes/No'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Radio.Group
                      onChange={handleCapacity}
                      className={styles.customRadio}
                      name="data_logger"
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </FormItem>
                </Col>
                <Col xs={24} xl={6} span={8}>
                  <FormItem
                    label="Vendor status label defaced"
                    name="labels_defaced"
                    rules={[
                      {
                        required: true,
                        message: 'Choose Yes/No'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Radio.Group
                      onChange={handleCapacity}
                      className={styles.customRadio}
                      name="labels_defaced"
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </FormItem>
                </Col>
                <Col xs={24} xl={6} span={8}>
                  <FormItem
                    label="Material dedusting status"
                    name="dedusting_status"
                    rules={[
                      {
                        required: true,
                        message: 'Choose Yes/No'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Radio.Group
                      onChange={handleCapacity}
                      className={styles.customRadio}
                      name="dedusting_status"
                    >
                      <Radio value="Yes">Performed</Radio>
                      <Radio value="No">Not performed</Radio>
                    </Radio.Group>
                  </FormItem>
                </Col>
                <Col xs={24} xl={6} span={8}>
                  <FormItem
                    label="Seal integrity of the containers"
                    name="seal_integrity"
                    rules={[
                      {
                        required: true,
                        message: 'Choose Yes/No'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Radio.Group
                      onChange={handleCapacity}
                      className={styles.customRadio}
                      name="seal_integrity"
                    >
                      <Radio value="Yes">Satisfactory</Radio>
                      <Radio value="No">Not satisfactory</Radio>
                    </Radio.Group>
                  </FormItem>
                </Col>
                <Col xs={24} xl={24} span={8}>
                  <FormItem
                    label="Comments"
                    name="material_ver_comments"
                    rules={[
                      {
                        required: false,
                        message: 'Enter comments'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <TextArea placeholder="Enter comments"></TextArea>
                  </FormItem>
                </Col>
              </Row>
              <FormItem className="text-center" style={{ marginTop: '20px' }}>
                <Space>
                  <CustomButton
                    htmlType="button"
                    onClick={handleStandardCancel}
                  >
                    Cancel
                  </CustomButton>
                  {truckShow ? (
                    <Spin size="large" />
                  ) : (
                    <CustomButton
                      type="primary"
                      htmlType="submit"
                      loading={loading}
                    >
                      Submit
                    </CustomButton>
                  )}
                </Space>
              </FormItem>
            </Card>
          )}

          {/* Only show submit button when vehicle storage is not in read-only mode */}
          {(!hasVehicleStorageData() || isVehicleStorageEdit) && (
            <FormItem className="text-center">
              <Space>
                {isVehicleStorageEdit ? (
                  <CustomButton
                    htmlType="button"
                    onClick={() => {
                      setIsVehicleStorageEdit(false);
                      // Reset form values to original
                      const vehicleStorage =
                        material?.vehicle_storage_area || material;
                      form.setFieldsValue({
                        vehicle_cleanliness: convertBooleanToString(
                          vehicleStorage?.vehicle_cleanliness
                        ),
                        storage_enclose: convertBooleanToString(
                          vehicleStorage?.storage_enclose
                        ),
                        storage_conditions: convertBooleanToString(
                          vehicleStorage?.storage_conditions
                        ),
                        veh_storage_comments:
                          vehicleStorage?.vehicle_storage_comments || ''
                      });
                    }}
                    className={styles.border_button}
                  >
                    Cancel
                  </CustomButton>
                ) : (
                  <CustomButton
                    htmlType="button"
                    onClick={handleStandardCancel}
                  >
                    Cancel
                  </CustomButton>
                )}
                {truckShow ? (
                  <Spin size="large" />
                ) : (
                  <CustomButton
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                  >
                    {isVehicleStorageEdit
                      ? 'Save'
                      : material?.material_status === 'veh_ver_approved'
                      ? 'Submit'
                      : 'Submit'}
                  </CustomButton>
                )}
              </Space>
            </FormItem>
          )}
        </Space>
        {/* </Space> */}
      </Form>
      {isModal ? (
        <VerificationModal
          isModal={isModal}
          materials={materials}
          setIsModal={setIsModal}
          material={material}
          setIsEdit={setIsEdit}
        />
      ) : (
        ''
      )}
    </Layout>
  );
};
export default InvoiceDetailsPage;
